import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ISendReceipt from '../../../../interfaces/sendReceipt/sendReceipt';
import FormikCheckbox from '../../../base/forms/formikCheckbox';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { Column, Columns } from '../../../base/grid';
import * as StyledInfo from './info.styles';

interface Props {
	values: ISendReceipt;
	setFieldValue: (x: string, y: boolean) => void;
}

const Info: FC<Props> = ({ values, setFieldValue }) => {
	const { t } = useTranslation('sendReceipt');
	const { foreignSsn } = values;
	const size = foreignSsn ? 3 : 2;
	return (
		<StyledInfo.Wrapper>
			<Columns>
				<Column tablet={1 / 2}>
					<FormikFieldWrapper name="foreignSsn" languageComponent="sendReceipt">
						<FormikCheckbox
							name="foreignSsn"
							id="foreignSsn"
							label={t('foreign-social-id')}
							setFieldValue={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>
			<Columns>
				<Column desktopSmall={1 / size} tablet={1 / 2}>
					<FormikFieldWrapper name="name" languageComponent="sendReceipt" label={`${t('name')} *`} smallLabel>
						<StyledFormikField type="text" id="name" name="name" placeholder={t('name')} />
					</FormikFieldWrapper>
				</Column>
				{!foreignSsn && (
					<Column desktopSmall={1 / size} tablet={1 / 2}>
						<FormikFieldWrapper
							name="identificationNumber"
							languageComponent="sendReceipt"
							smallLabel
							label={`${t('social-id')} ${values.foreignSsn ? '' : '*'}`}>
							<StyledFormikField
								type="text"
								id="identificationNumber"
								name="identificationNumber"
								placeholder={t('social-id')}
								maxLength={10}
							/>
						</FormikFieldWrapper>
					</Column>
				)}
				<Column desktopSmall={1 / size} tablet={1 / 2}>
					<FormikFieldWrapper
						name="email"
						languageComponent="sendReceipt"
						smallLabel
						label={`${t('email')} *`}>
						<StyledFormikField type="text" id="email" name="email" placeholder={t('email')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / size} tablet={1 / 2}>
					<FormikFieldWrapper
						name="phone"
						languageComponent="sendReceipt"
						smallLabel
						label={`${t('phone')} ${values.isCompany ? '' : '*'}`}>
						<StyledFormikField type="number" id="phone" name="phone" placeholder={t('phone')} />
					</FormikFieldWrapper>
				</Column>
			</Columns>
		</StyledInfo.Wrapper>
	);
};

export default Info;
